export const iconFontAwesomeTransportationSleigh = (
	<i className="fa-solid fa-sleigh"></i>
);
